import Vue from 'vue'
import Router from 'vue-router'
import { getStore } from '@/config/mUtils'
import store from '../store/'

Vue.use(Router)

const router = new Router({
    mode:'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: 'home' */ '@/pages/personal/login'),
        },
        {
            path: '/register',
            name: 'register',
            component: () => import(/* webpackChunkName: 'home' */ '@/pages/personal/register'),
        },
        {
            path: '/admin/login',
            name: 'adminLogin',
            component: () => import(/* webpackChunkName: 'admin' */ '@/pages/admin/login'),
        },
    ]
})
import {docRouter,patientRouter,guardianRouter,salesRouter,warehouse} from './staticRouter'
router.beforeEach(function (to, from, next) {
    var userInfo = getStore('userInfo');
    if(userInfo!=null){
        if(store.state.addRouter==0){
            if (userInfo.simpleRoleList[0]== '001') {
                router.addRoutes(patientRouter);
            }
            else if(userInfo.simpleRoleList[0]== '002'){
                router.addRoutes(docRouter);
            }
            else if(userInfo.simpleRoleList[0]== '003'){
                router.addRoutes(guardianRouter);
            }
            else if(userInfo.simpleRoleList[0]== '004'){
                router.addRoutes(salesRouter);
            }
            else if(userInfo.simpleRoleList[0]== '005'){
                router.addRoutes(warehouse);
            }
            store.state.addRouter=1
            next(to.path)
        }
        else{
            next()
        }
    }
    else{
        next()
    }
    

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js